import { Link as RouterLink } from 'react-router-dom';
import { IconButton, Link, Typography, Stack, Box } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';
import { useLayoutContext } from 'modules/common/components/Layout/LayoutContext';
import MemberAvatar from 'modules/common/components/Layout/common/MemberAvatar';
import { useMember } from 'modules/common/queries/member';

export default function DrawerHeader() {
    const { setIsSidebarHidden } = useLayoutContext();
    const { data: member } = useMember();

    return (
        <Stack padding={2} direction="row" justifyContent="space-between" position="relative">
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, width: 1 }}>
                <Box sx={{ display: 'inline-flex', width: '100%', gap: 1 }}>
                    <MemberAvatar />
                    <Stack direction="column" maxWidth="180px">
                        <Typography
                            component="a"
                            aria-label="business name"
                            color="cement.700"
                            variant="subtitle1"
                            width={1}
                            overflow="hidden"
                            whiteSpace="nowrap"
                            textOverflow="ellipsis">
                            {member?.businessname} {member?.incsuffix}.
                        </Typography>

                        <Link
                            underline="none"
                            component={RouterLink}
                            onClick={() => setIsSidebarHidden(true)}
                            to="/settings"
                            color="cement.600"
                            variant="subtitle1">
                            View profile
                        </Link>
                    </Stack>
                </Box>

                <IconButton
                    aria-label="close sidebar"
                    sx={{ alignSelf: 'flex-start' }}
                    onClick={() => setIsSidebarHidden(true)}>
                    <CloseXIcon />
                </IconButton>
            </Box>
        </Stack>
    );
}
